import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { quizQuestions, themes } from '../data/content';

const { FiX, FiArrowRight, FiArrowLeft } = FiIcons;

function QuizModal({ open, onClose }) {
  const [step, setStep] = useState(0);
  const [answers, setAnswers] = useState([]);
  const [email, setEmail] = useState('');
  const [notice, setNotice] = useState('');

  if (!open) return null;

  const result = themes[answers.reduce((sum, value) => sum + value, 0) % themes.length];

  const choose = (index) => {
    const next = [...answers];
    next[step] = index;
    setAnswers(next);
    setStep(step + 1);
  };

  const close = () => {
    setStep(0);
    setAnswers([]);
    setEmail('');
    setNotice('');
    onClose();
  };

  const submitEmail = (event) => {
    event.preventDefault();
    setNotice(email.includes('@')
      ? 'Your email is valid, but it has not been stored or subscribed.'
      : 'Please enter a valid email address.');
  };

  return (
    <AnimatePresence>
      <motion.div className="modal-backdrop" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
        <motion.div className="quiz-modal" initial={{ y: 30, opacity: 0 }} animate={{ y: 0, opacity: 1 }}>
          <button className="modal-close" onClick={close} aria-label="Close quiz"><SafeIcon icon={FiX} /></button>
          <span className="eyebrow">Little Shop in Paris</span>
          {step < quizQuestions.length ? (
            <>
              <div className="quiz-progress"><span style={{ width: `${((step + 1) / quizQuestions.length) * 100}%` }} /></div>
              <p className="script-kicker">Which life chapter are you in?</p>
              <h2>{quizQuestions[step].question}</h2>
              <div className="quiz-options">
                {quizQuestions[step].options.map((option, index) => (
                  <button key={option} onClick={() => choose(index)}>
                    <span>{String.fromCharCode(65 + index)}</span>{option}<SafeIcon icon={FiArrowRight} />
                  </button>
                ))}
              </div>
              <div className="quiz-footer">
                <span>{step + 1} of {quizQuestions.length}</span>
                {step > 0 && <button onClick={() => setStep(step - 1)}><SafeIcon icon={FiArrowLeft} /> Back</button>}
              </div>
            </>
          ) : (
            <div className="quiz-result">
              <p className="script-kicker">Your next chapter is</p>
              <h2>{result.name}</h2>
              <p>{result.note}. We recommend The Parcel, curated to bring beauty, momentum, and meaning to this season.</p>
              <form onSubmit={submitEmail}>
                <label htmlFor="quiz-email">Send this recommendation to your inbox</label>
                <div className="email-field light-field">
                  <input id="quiz-email" type="email" value={email} onChange={(event) => setEmail(event.target.value)} placeholder="you@example.com" required />
                  <button type="submit"><SafeIcon icon={FiArrowRight} /></button>
                </div>
                {notice && <p className="form-notice">{notice}</p>}
                <div data-greta-form-placeholder="CHAPTER_QUIZ_EMAIL">This form is not collecting yet.</div>
              </form>
            </div>
          )}
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
}

export default QuizModal;